import React from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Grid, Typography, Container } from "@mui/material";
import Intro from "../../../components/atoms/Intro/Intro.component";
import Content from "../../../components/layout/pageLayout/Content/Content.component";
import BoxedContent from "../../../components/layout/pageLayout/BoxedContent/BoxedContent.component";
import ParameterForm from "../../../components/admin/parameterManagement/ParameterCard/ParameterForm/ParameterForm.component";

import { parameterTypes } from "../../../constants";
import LabelsForm  from "../../../components/admin/parameterManagement/ParameterCard/ParameterForm/Labels";

const LabelsView = () => {
  const { id } = useParams();
  const location = useLocation();

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      to="/admin/parameter-management"
    >
      Parameter Management
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      to={`/admin/parameter-management/labels`}
    >
      Labels
    </Link>,
    <Typography key="3">{`view Labels`}</Typography>,
  ];

  return (
    <>
      <Intro
        pageTitle={`view Labels`}
        pageTitleShort={`view Labels`}
        breadcrumbs={breadcrumbs}
        additionalWidgets=""
      />

      <Content>
        <Container sx={{ ml: 0, px: "0 !important" }}>
          <BoxedContent
            title={`view Labels`}
            subtitle=""
            description=""
          >
            <Grid container spacing="2">
              <Grid item xs={12}>
                <LabelsForm mode={"view"} paramdata={{ id }} />
              </Grid>
            </Grid>
          </BoxedContent>
        </Container>
      </Content>
    </>
  );
};

export default LabelsView;
